import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';

function PhotoViewer({
  isShow,
  onClose,
  images,
  index
}) {
  const [photoIndex, setPhotoIndex] = useState(0);
  useEffect(() => {
    if (index) {
      setPhotoIndex(index);
    }
  }, [index]);

  function close() {
    setPhotoIndex(0);
    onClose();
  }

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Lightbox, {
    imageTitle: images[photoIndex].title,
    mainSrc: images[photoIndex].photo,
    nextSrc: images[(photoIndex + 1) % images.length].photo,
    prevSrc: images[(photoIndex + images.length - 1) % images.length].photo,
    onCloseRequest: close,
    onMovePrevRequest: () => setPhotoIndex(photoIndex => (photoIndex + images.length - 1) % images.length),
    onMoveNextRequest: () => setPhotoIndex(photoIndex => (photoIndex + 1) % images.length)
  });
}

export default PhotoViewer;